// Liquid file is located under /sections/product-list.liquid
document.addEventListener('DOMContentLoaded', function () {
  // Guard against this script being included more than once on the page
  if (window.__dmFeaturedCollectionCarouselInit) return;
  window.__dmFeaturedCollectionCarouselInit = true;

  // ===== Featured Collection carousel — scroll progress bar =====
  // This is a NATIVE Shopify slideshow-component (not a custom controller),
  // so this script doesn't drive slide-changing at all — it just watches
  // the carousel's real scroll position and reflects it as a fill percentage.
  //
  // Scoped to the Featured Collection section specifically (not just the
  // .resource-list__carousel class) — that class is SHARED with the
  // category-icons carousel, which was causing this script to also run
  // there and insert an unwanted progress bar on that carousel too.
  const featuredCollectionSection = document.getElementById('shopify-section-template--27533758071170__product_list_fa6P9H');
  if (!featuredCollectionSection) return;

  featuredCollectionSection.querySelectorAll('slideshow-component.resource-list__carousel').forEach(function (carousel) {
    const track = carousel.querySelector('slideshow-slides');
    const arrowsWrap = carousel.querySelector('slideshow-container > slideshow-arrows');
    if (!track || !arrowsWrap) return;

    // Build the progress bar
    const progressTrack = document.createElement('div');
    progressTrack.className = 'dm-carousel-progress-track';
    const progressFill = document.createElement('div');
    progressFill.className = 'dm-carousel-progress-fill';
    progressTrack.appendChild(progressFill);

    // Wrap the bar + arrows together in one flex row so they're
    // guaranteed to sit on the exact same line, instead of each being
    // positioned independently with separate offsets that can drift
    // out of alignment.
    //
    // IMPORTANT: capture the original parent BEFORE moving arrowsWrap —
    // once arrowsWrap is appended into bottomRow, arrowsWrap.parentElement
    // becomes bottomRow itself, so reading it afterward causes
    // bottomRow.appendChild(bottomRow), a self-append the DOM rejects.
    const originalParent = arrowsWrap.parentElement;
    const bottomRow = document.createElement('div');
    bottomRow.className = 'dm-carousel-bottom-row';
    bottomRow.appendChild(progressTrack);
    bottomRow.appendChild(arrowsWrap); // moves the existing arrows element in
    originalParent.appendChild(bottomRow);

    // Tag these specific arrow buttons with a unique class, so CSS can
    // target them directly and can't accidentally match any other arrows
    // on the page (per-product image galleries, hero slideshow, etc.)
    const prevBtn = arrowsWrap.querySelector('.slideshow-control--previous');
    const nextBtn = arrowsWrap.querySelector('.slideshow-control--next');
    if (prevBtn) prevBtn.classList.add('dm-fc-arrow', 'dm-fc-arrow--prev');
    if (nextBtn) nextBtn.classList.add('dm-fc-arrow', 'dm-fc-arrow--next');

    function updateProgress() {
      const maxScroll = track.scrollWidth - track.clientWidth;
      const percent = maxScroll > 0 ? (track.scrollLeft / maxScroll) * 100 : 0;
      progressFill.style.width = percent + '%';
    }

    track.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress);
    updateProgress();
  });

  // ===== Sale badge injection =====
  // The product card markup comes from a native Shopify block
  // (_product-card) that this theme's section file can't inject custom
  // Liquid into. A product is "on sale" when it renders a strikethrough
  // regular price alongside the current price — .price-item--regular
  // (or <s>/<del>) only appears in that case, so its presence is a
  // reliable signal without needing direct access to the product object.
  featuredCollectionSection.querySelectorAll('product-card').forEach(function (card) {
    const hasCompareAtPrice = card.querySelector(
      'product-price .price-item--regular, product-price s, product-price del'
    );
    if (!hasCompareAtPrice) return;

    // Skip if this card already has a native Shopify sale badge — some
    // products have the theme's built-in badge feature enabled, and we
    // don't want to show two "Sale" pills on the same card.
    const hasNativeBadge = card.querySelector('.product-badges__badge');
    if (hasNativeBadge) return;

    const gallery = card.querySelector('.card-gallery');
    if (!gallery || gallery.querySelector('.dm-sale-badge')) return;

    const badge = document.createElement('div');
    badge.className = 'dm-sale-badge';
    badge.textContent = 'Sale';
    gallery.appendChild(badge);
  });
});